import AppConfigDetail from "@saleor/appConfiguration/components/AppConfigDetail/AppConfigDetail";
import { useAppConfigurationDetailQuery } from "@saleor/appConfiguration/queries";
import {
  appConfigurationUrl,
  AppConfigurationUrlQueryParams
} from "@saleor/appConfiguration/url";
import { DEFAULT_INITIAL_PAGINATION_DATA } from "@saleor/config";
import useListSettings from "@saleor/hooks/useListSettings";
import useNavigator from "@saleor/hooks/useNavigator";
import usePaginator, {
  createPaginationState
} from "@saleor/hooks/usePaginator";
import { maybe } from "@saleor/misc";
import { ListViews } from "@saleor/types";
import { AppConfigOrderField, OrderDirection } from "@saleor/types/globalTypes";
import * as React from "react";
interface AppConfigurationDetailProps {
  id: string;
  params: AppConfigurationUrlQueryParams;
}

const AppConfigurationDetail: React.FC<AppConfigurationDetailProps> = ({
  id,
  params
}) => {
  const navigate = useNavigator();
  const paginate = usePaginator();
  const { settings, updateListSettings } = useListSettings(
    ListViews.APPCONFIGDETAIL_LIST
  );

  const paginationState = createPaginationState(settings.rowNumber, params);
  const queryVariables = React.useMemo(
    () => ({
      ...paginationState
    }),
    [params]
  );

  const sort = {
    sort: {
      direction: OrderDirection.DESC,
      field: AppConfigOrderField.VERSION
    }
  };

  const { data, loading, refetch } = useAppConfigurationDetailQuery({
    displayLoader: true,
    variables: {
      id,
      ...queryVariables,
      ...sort
    }
  });

  const { loadNextPage, loadPreviousPage, pageInfo } = paginate(
    maybe(() => data.appConfig.appConfigs.pageInfo),
    paginationState,
    params
  );

  React.useEffect(
    () =>
      navigate(
        appConfigurationUrl(id, {
          ...params,
          ...DEFAULT_INITIAL_PAGINATION_DATA
        }),
        true
      ),
    [settings.rowNumber]
  );

  return (
    <AppConfigDetail
      appConfig={data?.appConfig}
      params={params}
      loading={loading}
      refetch={refetch}
      settings={settings}
      onNextPage={loadNextPage}
      onPreviousPage={loadPreviousPage}
      onUpdateListSettings={updateListSettings}
      pageInfo={pageInfo}
      disabled={loading}
      onRowClick={() => undefined}
    />
  );
};

export default AppConfigurationDetail;
